export default {
      id: "rt-usage",
      viewBox: "0 0 112 98",
      url: __webpack_public_path__ + "sprite.svg#rt-usage",
      toString: function () {
        return this.url;
      }
    }